import { useEffect, useState } from 'react';
import { adminAPI } from '../../services/api';
import toast from 'react-hot-toast';

const STATUS = {
  active:    { bg:'#D1FAE5',color:'#065F46',label:'Ativo' },
  trial:     { bg:'#FEF3C7',color:'#92400E',label:'Teste' },
  overdue:   { bg:'#FEE2E2',color:'#991B1B',label:'Inadimplente' },
  blocked:   { bg:'#F3F4F6',color:'#374151',label:'Bloqueado' },
  cancelled: { bg:'#FEE2E2',color:'#991B1B',label:'Cancelado' },
};

export default function AdminTenants() {
  const [tenants, setTenants] = useState([]);
  const [meta,    setMeta]    = useState({});
  const [search,  setSearch]  = useState('');
  const [status,  setStatus]  = useState('');
  const [page,    setPage]    = useState(1);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await adminAPI.tenants({ search, status, page, limit: 25 });
      setTenants(r.data.data); setMeta(r.data.meta);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [search, status, page]);

  const action = async (fn, msg) => {
    try { await fn(); toast.success(msg); load(); }
    catch (e) { toast.error(e.response?.data?.message || 'Erro.'); }
  };

  return (
    <div>
      <h1 style={{ fontSize:'1.5rem',fontWeight:700,color:'#0F172A',marginBottom:24 }}>Clientes SaaS</h1>

      <div style={{ display:'flex',gap:12,marginBottom:20,flexWrap:'wrap' }}>
        <input value={search} onChange={e=>{setSearch(e.target.value);setPage(1)}} placeholder="Buscar empresa..."
          style={{ flex:1,padding:'8px 14px',border:'1.5px solid #E5E7EB',borderRadius:8,outline:'none',minWidth:200 }} />
        <select value={status} onChange={e=>setStatus(e.target.value)}
          style={{ padding:'8px 14px',border:'1.5px solid #E5E7EB',borderRadius:8,outline:'none' }}>
          <option value="">Todos</option>
          {Object.entries(STATUS).map(([v,{label}]) => <option key={v} value={v}>{label}</option>)}
        </select>
      </div>

      <div style={{ background:'#fff',borderRadius:12,border:'1px solid #E5E7EB',overflow:'auto' }}>
        <table style={{ width:'100%',borderCollapse:'collapse',minWidth:800 }}>
          <thead><tr style={{ background:'#F8FAFC',borderBottom:'1px solid #E5E7EB' }}>
            {['Empresa','E-mail','Plano','Status','Cadastro','O.S./Mês','Ações'].map(h=>(
              <th key={h} style={{ padding:'12px 16px',textAlign:'left',fontSize:'.8rem',fontWeight:600,color:'#6B7280' }}>{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {loading ? <tr><td colSpan={7} style={{ padding:40,textAlign:'center' }}>Carregando...</td></tr>
            : tenants.length===0 ? <tr><td colSpan={7} style={{ padding:40,textAlign:'center',color:'#9CA3AF' }}>Nenhum cliente.</td></tr>
            : tenants.map(t => {
              const s = STATUS[t.status] || STATUS.blocked;
              return (
                <tr key={t.id} style={{ borderBottom:'1px solid #F1F5F9' }}>
                  <td style={{ padding:'12px 16px',fontWeight:600 }}>{t.name}</td>
                  <td style={{ padding:'12px 16px',fontSize:'.85rem',color:'#6B7280' }}>{t.email}</td>
                  <td style={{ padding:'12px 16px',fontSize:'.85rem' }}>{t.plan_name}</td>
                  <td style={{ padding:'12px 16px' }}>
                    <span style={{ background:s.bg,color:s.color,borderRadius:6,padding:'3px 10px',fontSize:'.75rem',fontWeight:600 }}>{s.label}</span>
                  </td>
                  <td style={{ padding:'12px 16px',fontSize:'.8rem',color:'#9CA3AF' }}>
                    {new Date(t.created_at).toLocaleDateString('pt-BR')}
                  </td>
                  <td style={{ padding:'12px 16px',fontSize:'.85rem' }}>{t.orders_this_month}</td>
                  <td style={{ padding:'12px 16px' }}>
                    <div style={{ display:'flex',gap:6 }}>
                      {t.status !== 'blocked' && t.status !== 'cancelled' && (
                        <button onClick={()=>action(()=>adminAPI.tenantBlock(t.id),'Bloqueado.')}
                          style={{ background:'#FEE2E2',color:'#DC2626',border:'none',borderRadius:6,padding:'4px 10px',cursor:'pointer',fontSize:'.75rem',fontWeight:600 }}>
                          Bloquear
                        </button>
                      )}
                      {t.status === 'blocked' && (
                        <button onClick={()=>action(()=>adminAPI.tenantUnblock(t.id),'Desbloqueado.')}
                          style={{ background:'#D1FAE5',color:'#059669',border:'none',borderRadius:6,padding:'4px 10px',cursor:'pointer',fontSize:'.75rem',fontWeight:600 }}>
                          Desbloquear
                        </button>
                      )}
                      {t.status !== 'cancelled' && (
                        <button onClick={()=>{if(window.confirm('Cancelar assinatura?'))action(()=>adminAPI.tenantCancel(t.id),'Cancelado.')}}
                          style={{ background:'#F3F4F6',color:'#374151',border:'none',borderRadius:6,padding:'4px 10px',cursor:'pointer',fontSize:'.75rem',fontWeight:600 }}>
                          Cancelar
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
